import { type LazyQueryHookOptions, useLazyQuery } from "@apollo/client";
import { BunnyAccountLibrariesQuery } from "../graphql/queries";
import type {
  BunnyAccountLibrariesQueryType,
  BunnyAccountLibrariesQueryVariablesType,
} from "@/types/graphql/partner.generated";

/**
 * Ленивый запрос: аккаунтный ключ вводит партнёр, и до нажатия «Load
 * libraries» спрашивать Bunny не о чем.
 *
 * `no-cache`, а не `network-only`: последний ходит в сеть, но результат
 * всё равно пишет в кеш Apollo, а вместе с ним туда попадает и сам запрос
 * с аккаунтным ключом в переменных. Аккаунтный ключ не должен оседать
 * нигде, кроме состояния формы, поэтому кеш выключен целиком.
 */
export const useBunnyAccountLibrariesLazyQuery = (
  options?: LazyQueryHookOptions<
    BunnyAccountLibrariesQueryType,
    BunnyAccountLibrariesQueryVariablesType
  >
) => {
  return useLazyQuery<
    BunnyAccountLibrariesQueryType,
    BunnyAccountLibrariesQueryVariablesType
  >(BunnyAccountLibrariesQuery, { fetchPolicy: "no-cache", ...options });
};
